import { Pipe, PipeTransform } from '@angular/core';
import { toDateTimeFormat } from '@mri/functions';

@Pipe({
  name: 'toDateTimeFormat',
  standalone: true
})
export class ToDateTimeFormatPipe implements PipeTransform {

  transform(value?: Date | string): string {
    return toDateTimeFormat(value);
  }

}
